import { render, staticRenderFns } from "./PopupCaptcha.vue?vue&type=template&id=5167d03f&scoped=true&"
import script from "./PopupCaptcha.vue?vue&type=script&lang=js&"
export * from "./PopupCaptcha.vue?vue&type=script&lang=js&"
import style0 from "./PopupCaptcha.vue?vue&type=style&index=0&id=5167d03f&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5167d03f",
  null
  
)

export default component.exports